export function generateQueryString(params?: any) {
	if (!params) return "";

	const query = Object.keys(params)
		.map((key) => {
			if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
				return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]) + "&";
			}
			return null;
		})
		.filter(Boolean)
		.join("")
		.slice(0, -1);

	return query ? "?" + query : "";
}
